import React from "react";
import { Modal, Select, DatePicker, TreeSelect } from "antd";
import moment from "moment";
const { TreeNode } = TreeSelect;
const { Option } = Select;
export const EditMultipleTransaction = ({
  handleChange,
  editModal,
  editModalData,
  handleCancelEditModal,
  handleSaveEditModal,
  handleDeleteEditModal,
  categories,
  clientBanks,
  data,
}) => {
  return (
    <Modal visible={editModal} footer={null} closable={false} centered>
      <h3 className="modaltitle">Edit Transactions</h3>
      <div style={{ marginBottom: "8px" }}>
        <h3 className="inputTitle">Category</h3>
        <TreeSelect
          showSearch
          dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
          placeholder="Choose Category"
          allowClearclientBanks
          value={editModalData && editModalData.categoryName}
          onChange={(value, label, extra) => {
            const selectedNode = extra.triggerNode;
            const parentNode = selectedNode && selectedNode.props.label;
            const selectedCategory = parentNode
              ? `${value}-${parentNode}`
              : value;
            console.log("selectedCategory", selectedCategory);
            handleChange("category", selectedCategory);
          }}
        >
          {categories &&
            categories.map((category) => {
              let parentLabel = category.categoryName;
              return (
                <TreeNode
                  key={category.id}
                  value={category.categoryName}
                  title={category.categoryName}
                >
                  {category.subCategories.map((subCategory, index) => (
                    <TreeNode
                      key={`${category.id}-${index}`}
                      value={subCategory.name}
                      title={subCategory.name}
                      label={parentLabel}
                    />
                  ))}
                </TreeNode>
              );
            })}
        </TreeSelect>
      </div>
      <div style={{ marginBottom: "8px" }}>
        <h3 className="inputTitle">Bank Account</h3>
        <Select
          showSearch
          placeholder="-Select-"
          value={editModalData && editModalData.accountTitle}
          onChange={(value, id) => {
            handleChange("accountTitle", value);
          }}
        >
          {clientBanks &&
            clientBanks.map((item, index) => (
              <Option key={index} value={item.accountTitle}>
                {item.accountTitle}
              </Option>
            ))}
        </Select>
      </div>
      <div style={{ marginBottom: "8px" }}>
        <h3 className="inputTitle">
          Date
          {/* <span style={{ color: "red" }}>*</span> */}
        </h3>
        <DatePicker
          style={{
            width: "100%",
            border: "1px solid #d1d5db",
            borderRadius: "5px",
          }}
          size="large"
          format={"MM/DD/YYYY"}
          placeholder="Date"
          name="date"
          value={
            editModalData &&
            editModalData.date &&
            moment.utc(editModalData.date)
          }
          id="newDate"
          onChange={(date, dateString) => {
            handleChange("date", dateString);
          }}
        />
      </div>
      <button
        className="savebutton"
        style={{ width: "100%" }}
        onClick={() => {
          handleDeleteEditModal();
        }}
      >
        Delete
      </button>
      <div className="buttonsMain">
        <button
          className={data && data ? "savebutton" : "savebutton disableButton"}
          disabled={data && data ? false : true}
          onClick={() => {
            handleSaveEditModal();
          }}
        >
          Save
        </button>
        <button
          className="cancelbutton"
          onClick={() => {
            handleCancelEditModal();
          }}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};
